import { baromoneyService } from '@/services';
export default {
    async setBaromoneyRemittanceReceiver({ commit }, payload) {
        commit('SET_REMITTANCE_RECEIVER', payload);
    },
    async requestBaromoneyRemittance({ commit }, payload = {}) {
        const { orderId = '', senderName = '', receiverDistributorId = '', receiverHubId = '', receiverCode = '', receiverName = '', receiverAccountType = '', remittanceBaromoney = '', memo = '', } = payload;
        const response = await baromoneyService.requestBaromoneyRemittance({
            orderId,
            senderName,
            receiverDistributorId,
            receiverHubId,
            receiverCode,
            receiverName,
            receiverAccountType,
            remittanceBaromoney,
            memo,
        });
        const { data } = response;
        commit('SET_REMITTANCE', data);
        return data;
    },
};
